module.exports = __webpack_public_path__ + "img/CompassNeedle.ffd2f2ee.svg";